import React from "react";
import { useNavigate } from "react-router";
import SecondaryButton from "../buttons/SecondaryButton";

export const BackButton = ({editLocation,editTrial,classes,onClick}) => {
    const navigate = useNavigate()
    const handleBack = (e) => {
        e.preventDefault();
        navigate(editLocation?'/locations':editTrial?'/trials':-1); // This goes back to the previous screen
    };
    return <SecondaryButton label="Cancel" onClick={onClick?onClick:handleBack} classes={classes} />
};